import Vue from 'vue'
import Vuex from 'vuex'
import { getUserInfo } from '@/api/login'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: null,
    roles: [],
    menus: [],
    perms: [],   // 当前用户拥有的按钮权限标识符列表
    menuIds: []  // 当前用户角色拥有的菜单ID列表
  },
  getters: {
    hasPerm: (state) => (identifier) => {
      if (!identifier) return true
      return state.perms.includes(identifier)
    }
  },
  mutations: {
    SET_USER_INFO(state, info) {
      state.userInfo = info
    },
    SET_ROLES(state, roles) {
      state.roles = roles
    },
    SET_MENUS(state, menus) {
      state.menus = menus
    },
    SET_PERMS(state, perms) {
      state.perms = perms
    },
    SET_MENU_IDS(state, menuIds) {
      state.menuIds = menuIds
    }
  },
  actions: {
    getUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          commit('SET_USER_INFO', res)
          commit('SET_MENU_IDS', res.menuIds || [])
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
})
